import {SET_DATE_MODAL} from "../../types";

const initialState = {
    modalShow: false,
    newChosenDate: null,
    sendData: false
}

export const modalSetDateReducer = (state = initialState, action) => {

    switch (action.type) {
        case SET_DATE_MODAL :
            return {...state, ...action.payload};
        default: return state;
    }

}